module.exports = __webpack_public_path__ + "static/template_list_week_with_tasks-987e2a2d212a512047feed3c64ebfc64.png";